import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { acceptAgeCheck } from '../../state/ducks/ageCheck/actions';
import './AgeCheckComponent.scss';
import Logo from '../../images/logo.png';

export default () => {
  const dispatch = useDispatch();

  const ageCheckPassed = useSelector((state) => state.ageCheck.ageCheckAccepted);

  function accept() {
    dispatch(acceptAgeCheck());
  }

  if (!ageCheckPassed) {
    return (
      <div className="age-check-component">
        <div className="background" />
        <div className="stage">
          <div className="logo-container">
            <img src={Logo} alt="Metrc" />
          </div>
          <div className="content">
            <h1>Confirm Your Age</h1>
            <h4>
              You must be 21 years of age or older to view this site.
            </h4>
            <button
              type="button"
              className="btn btn-primary btn-lg m-3"
              onClick={() => accept()}
            >
              I AM 21 OR OLDER
            </button>
            <a
              className="btn btn-secondary btn-lg m-3"
              href="https://www.metrc.com"
            >
              Exit
            </a>
          </div>
        </div>
      </div>
    );
  }
  return '';
};
